/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'tiger',
    quality: 0.3,
	perception: 1,
	strength: 1,
	dexterity: 1
}